import styled from 'styled-components';
import styleUtils from '../../styles/style.utils';
import mediaBreakpoints from '../../styles/media-breakpoints';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 600;
  margin: 0 auto;
  width: 100%;
  max-width: ${styleUtils.size('MAX_CONTAINER_WIDTH')};
  padding-left: ${styleUtils.px(16)};
  padding-right: ${styleUtils.px(16)};

  ${mediaBreakpoints.between('XS', 'M')`
    margin: ${styleUtils.px(26)} auto 0 auto;
    padding-left: 0;
    padding-right: 0;
  `};

  ${mediaBreakpoints.greaterThan('M')`
    margin: ${styleUtils.px(54)} auto 0 auto;
  `};
`;

const DispatchPageComponents = { Container };

export default DispatchPageComponents;
